<template>
  <div>
    <div class="common-form">添加公告</div>
    <el-form ref="form" :model="form" label-width="200px">
      <el-form-item label="公告名称" :rules="[{ required: true, message: '请填写公告名称' }]">
        <el-input class="max-w460" v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="公告内容" :rules="[{ required: true, message: '请填写公告内容' }]">
        <el-input class="max-w460" v-model="form.desc"></el-input>
      </el-form-item>
      <!-- <el-form-item label="公告类型" :rules="[{ required: true, message: '请选择公告类型' }]">
        <el-radio-group v-model="form.notice_type">
          <el-radio :label="1">技师</el-radio>
          <el-radio :label="0">暂无类型</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item label="是否显示" :rules="[{ required: true, message: '请选择是否显示' }]">
        <el-radio-group v-model="form.is_show">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="排序" :rules="[{ required: true, message: '请填写排序' }]">
        <el-input class="max-w460" v-model="form.notice_sort" type="number"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">立即添加</el-button>

      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import NoticeApi from "@/api/notice.js";
export default {
  data() {
    return {
      form: {
        is_show: 1,
        // notice_type: 1,
        title: "",
        notice_sort: 100,
        desc: ""
      }
    };
  },
  created() {},

  methods: {
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          NoticeApi.noticeAdd(self.form, true)
            .then(data => {
              self.$message({
                message: "添加成功",
                type: "success"
              });
              self.from = {
                is_show: 1,
                title: "",
                notice_sort: 100,
                desc: ""
              };
              self.$router.push("/technician/qita/index");
            })
            .catch(error => {});
        }
      });
    }
  }
};
</script>




<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/qita/notice/add.vue